export default __webpack_public_path__ + "static/sd-logo-27b3834b36b8114f6dbc549225432fa1.svg";